import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function Shop() {
  // useEffect(() => {
  //   $("select").niceSelect(); // initialize after render
  // }, [categories]);
  const API_URL = "https://sunrisemeditechsystems.com/api"; // Define your backend API URL
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [sortBy, setSortBy] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [viewMode, setViewMode] = useState("grid"); // 'grid' or 'list'
  const [cartProductIds, setCartProductIds] = useState([]);
  const [wishlistProductIds, setWishlistProductIds] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      axios
        .get(`${API_URL}/cart`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          console.log("Cart API response:", res.data);
          // Handle both array of objects and array of strings
          let ids = [];
          if (Array.isArray(res.data.products)) {
            if (typeof res.data.products[0] === "object") {
              ids = res.data.products.map(
                (p) => p.productId?.toString?.() ?? p.toString()
              );
            } else {
              ids = res.data.products.map((p) => p.toString());
            }
          }
          setCartProductIds(ids);
        })
        .catch(() => setCartProductIds([]));
      axios
        .get(`${API_URL}/wishlist`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          console.log("Wishlist API response:", res.data);
          let ids = [];
          if (Array.isArray(res.data.products)) {
            if (typeof res.data.products[0] === "object") {
              ids = res.data.products.map(
                (p) => p.productId?.toString?.() ?? p.toString()
              );
            } else {
              ids = res.data.products.map((p) => p.toString());
            }
          }
          setWishlistProductIds(ids);
        })
        .catch(() => setWishlistProductIds([]));
    }
  }, []);
  useEffect(() => {
    // Ensure jQuery and niceSelect are loaded before attempting to use them
    if (
      typeof window !== "undefined" &&
      window.$ &&
      typeof window.$.fn.niceSelect === "function"
    ) {
      const $sortBySelect = window.$('select.nice-select[name="sortBy"]');
      const $categorySelect = window.$('select.nice-select[name="category"]');
      if ($sortBySelect.data("niceSelect")) {
        $sortBySelect.niceSelect("update");
      } else {
        $sortBySelect.niceSelect();
      }
      if ($categorySelect.data("niceSelect")) {
        $categorySelect.niceSelect("update");
      } else {
        $categorySelect.niceSelect();
      }
      return () => {
        if ($sortBySelect.data("niceSelect")) {
          $sortBySelect.niceSelect("destroy");
        }
        if ($categorySelect.data("niceSelect")) {
          $categorySelect.niceSelect("destroy");
        }
      };
    }
  }, [sortBy, selectedCategory, categories]);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_URL}/products?search=${searchTerm}&category=${selectedCategory}&sortBy=${sortBy}&sortOrder=${sortOrder}`
      );
      setProducts(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching products:", error);
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API_URL}/categories`);
      console.log("data", response.data);
      const category_detail = response.data;
      const formattedCategories = category_detail.map((element) => ({
        id: element.id,
        name: element.name,
      }));

      setCategories(formattedCategories);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  useEffect(() => {
    fetchProducts();
  }, [searchTerm, selectedCategory, sortBy, sortOrder]);

  useEffect(() => {
    fetchCategories();
  }, []);

  // Handle Add to Cart Click
  const handleCartClick = (e, productId) => {
    e.preventDefault();
    const token = localStorage.getItem("userToken");
    if (!token) {
      // navigate('/login', { state: { from: 'cart' } });
      Swal.fire(
        "Login Required",
        "Please login to proceed to checkout.",
        "info"
      );
      return;
    }
    localStorage.setItem("wishlist_detail", "cart");
    navigate(`/product/${productId}`);
    // Compare as strings for robustness
    if (
      cartProductIds.map((id) => id.toString()).includes(productId.toString())
    ) {
      navigate("/cart");
    } else {
      navigate(`/product/${productId}`);
    }
  };

  // Handle Add to Wishlist Click
  const handleWishlistClick = (e, productId) => {
    e.preventDefault();
    const token = localStorage.getItem("userToken");
    if (!token) {
      // navigate('/login', { state: { from: 'wishlist' } });
      Swal.fire(
        "Login Required",
        "Please login to proceed to checkout.",
        "info"
      );
      return;
    }
    localStorage.setItem("wishlist_detail", "wishlist");
    if (
      wishlistProductIds
        .map((id) => id.toString())
        .includes(productId.toString())
    ) {
      navigate("/wishlist");
    } else {
      navigate(`/product/${productId}`);
    }
  };

  return (
    <>
      {/* BREADCRUMB AREA START */}
      <div
        className="ltn__breadcrumb-area text-left bg-overlay-white-30 bg-image"
        data-bs-bg="img/bg/sunrise-medical.jpg"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__breadcrumb-inner">
                <h1 className="page-title">Shop</h1>
                <div className="ltn__breadcrumb-list">
                  <ul>
                    <li>
                      <Link to="/" className="bg-black-color">
                        <span className="ltn__secondary-color">
                          <i className="fas fa-home bg-black-color" />
                        </span>{" "}
                        Home
                      </Link>
                    </li>
                    <li>Shop</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* BREADCRUMB AREA END */}

      {/* PRODUCT DETAILS AREA START */}
      <div className="ltn__product-area ltn__product-gutter mb-120">
        <div className="container-fluid" style={{ width: "92%" }}>
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__shop-options">
                <ul>
                  {/* <li>
                    <div className="ltn__grid-list-tab-menu">
                      <div className="nav">
                        <Link
                          className={`${
                            viewMode === "grid" ? "active show" : ""
                          }`}
                          onClick={() => setViewMode("grid")}
                          to="#!"
                        >
                          <i className="fas fa-th-large" />
                        </Link>
                        <Link
                          className={`${
                            viewMode === "list" ? "active show" : ""
                          }`}
                          onClick={() => setViewMode("list")}
                          to="#!"
                        >
                          <i className="fas fa-list" />
                        </Link>
                      </div>
                    </div>
                  </li> */}
                  <li>
                    <div className="showing-product-number text-right">
                      <span>Showing {products.length} products</span>
                    </div>
                  </li>
                </ul>
              </div>

              {/* Search, Sort, and Filter Section */}
          
              <div className="row mb-4">
                <div className="col-md-4">
                  <div className="d-flex gap-3">
                    <select
                      className="form-select flex-grow-1"
                      value={sortBy}
                      style={{height:"50px"}}
                      onChange={(e) => {
                        const newSortBy = e.target.value;
                        if (newSortBy === sortBy) {
                          setSortOrder((prevOrder) =>
                            prevOrder === "asc" ? "desc" : "asc"
                          );
                        } else {
                          setSortOrder("asc");
                        }
                        setSortBy(newSortBy);
                      }}
                      name="sortBy"
                    >
                      <option value="name">Sort by Name</option>
                      <option value="salePrice">Sort by Sale Price</option>
                      <option value="rentalPrice">Sort by Rental Price</option>
                    </select>
                    <input
                      type="text"
                      className="form-control flex-grow-1"
                      placeholder="Search products..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{ height: "50px" }}
                    />

                    {/* <select
                      className="form-select flex-grow-1" style={{display:"block!important"}}
                      value={selectedCategory}
                      onChange={(e) => setSelectedCategory(e.target.value)}
                      name="category"
                    >
                      <option value="">All Categories</option>
                      {categories.map((category) => (
                        <option key={category._id} value={category._id}>
                          {category.name}
                        </option>
                      ))}
                    </select> */}
                  </div>
                </div>
              </div>

              <div className="tab-content">
                <div
                  className={`tab-pane fade ${
                    viewMode === "grid" ? "active show" : ""
                  }`}
                >
                  <div className="ltn__product-tab-content-inner ltn__product-grid-view">
                    <div className="row">
                      {loading ? (
                        <div className="col-12 text-center">
                          <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      ) : products.length === 0 ? (
                        <div className="col-12 text-center">
                          <p>No products found</p>
                        </div>
                      ) : (
                        products.map((product) => (
                          <div
                            key={product.id}
                            className="col-xl-3 col-lg-4 col-sm-6 col-6 mb-20"
                          >
                            <div className="ltn__product-item ltn__product-item-3 text-center">
                              <div
                                className="product-img"
                                style={{
                                  height: "250px",
                                  overflow: "hidden",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Link to={`/product/${product.id}`}>
                                  <img
                                    src={`https://sunrisemeditechsystems.com${product.image}`}
                                    alt={product.name}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                </Link>
                                <div className="product-badge">
                                  <ul>
                                    {product.salePrice <
                                      product.rentalPrice && (
                                      <li className="sale-badge">
                                        Best for Sale
                                      </li>
                                    )}
                                    {product.rentalPrice <
                                      product.salePrice && (
                                      <li className="sale-badge">
                                        Best for Rent
                                      </li>
                                    )}
                                  </ul>
                                </div>
                                <div className="product-hover-action">
                                  <ul>
                                    <li>
                                      <Link
                                        to={`/product/${product.id}`}
                                        title="Quick View"
                                        onClick={() => {
                                          localStorage.setItem(
                                            "wishlist_detail",
                                            "cart"
                                          );
                                        }}
                                      >
                                        <i className="far fa-eye" />
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        to="/cart"
                                        title="Add to Cart"
                                        className="add-to-cart"
                                        onClick={(e) =>
                                          handleCartClick(e, product.id)
                                        }
                                      >
                                        <i className="fas fa-shopping-cart" />
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        to="/wishlist"
                                        title="Wishlist"
                                        className="add-to-wishlist"
                                        onClick={(e) =>
                                          handleWishlistClick(e, product.id)
                                        }
                                      >
                                        <i className="far fa-heart" />
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div className="product-info">
                                <h2 className="product-title">
                                  <Link to={`/product/${product.id}`}>
                                    {product.name}
                                  </Link>
                                </h2>
                                <div className="product-price">
                                  <span>₹{product.salePrice}</span>
                                  <del>₹{product.rentalPrice}/day</del>
                                </div>
                                <div className="product-availability">
                                  {product.saleStock <= 0 && (
                                    <span className="badge bg-danger">
                                      Out of Stock (Buy)
                                    </span>
                                  )}
                                  {product.isRentalAvailable &&
                                    product.rentalStock <= 0 && (
                                      <span
                                        className="badge bg-warning"
                                        style={{ marginLeft: 6 }}
                                      >
                                        Out of Stock (Rent)
                                      </span>
                                    )}
                                  {product.saleStock > 0 &&
                                    (!product.isRentalAvailable ||
                                      product.rentalStock > 0) && (
                                      <span className="badge bg-success">
                                        Available
                                      </span>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className={`tab-pane fade ${
                    viewMode === "list" ? "active show" : ""
                  }`}
                >
                  <div className="ltn__product-tab-content-inner ltn__product-list-view">
                    <div className="row">
                      {loading ? (
                        <div className="col-12 text-center">
                          <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      ) : products.length === 0 ? (
                        <div className="col-12 text-center">
                          <p>No products found</p>
                        </div>
                      ) : (
                        products.map((product) => (
                          <div key={product.id} className="col-12">
                            <div className="ltn__product-item ltn__product-item-3">
                              <div className="row">
                                <div className="col-md-3">
                                  <div
                                    className="product-img"
                                    style={{
                                      height: "300px",
                                      overflow: "hidden",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Link to={`/product/${product.id}`}>
                                      <img
                                        src={`https://sunrisemeditechsystems.com${product.image}`}
                                        alt={product.name}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "contain",
                                        }}
                                      />
                                    </Link>
                                    <div className="product-badge">
                                      <ul>
                                        {product.salePrice <
                                          product.rentalPrice && (
                                          <li className="sale-badge">
                                            Best for Sale
                                          </li>
                                        )}
                                        {product.rentalPrice <
                                          product.salePrice && (
                                          <li className="sale-badge">
                                            Best for Rent
                                          </li>
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-9">
                                  <div className="product-info">
                                    <h2 className="product-title">
                                      <Link to={`/product/${product.id}`}>
                                        {product.name}
                                      </Link>
                                    </h2>
                                    <div className="product-price">
                                      <span>₹{product.salePrice}</span>
                                      <del>₹{product.rentalPrice}/day</del>
                                    </div>
                                    <div className="product-description">
                                      <p>{product.description}</p>
                                    </div>
                                    <div className="product-availability">
                                      {product.saleStock <= 0 && (
                                        <span className="badge bg-danger">
                                          Out of Stock (Buy)
                                        </span>
                                      )}
                                      {product.isRentalAvailable &&
                                        product.rentalStock <= 0 && (
                                          <span
                                            className="badge bg-warning"
                                            style={{ marginLeft: 6 }}
                                          >
                                            Out of Stock (Rent)
                                          </span>
                                        )}
                                      {product.saleStock > 0 &&
                                        (!product.isRentalAvailable ||
                                          product.rentalStock > 0) && (
                                          <span className="badge bg-success">
                                            Available
                                          </span>
                                        )}
                                    </div>
                                    <div className="product-hover-action">
                                      <ul>
                                        <li>
                                          <Link
                                            to={`/product/${product.id}`}
                                            title="Quick View"
                                          >
                                            <i className="far fa-eye" />
                                          </Link>
                                        </li>
                                        <li>
                                          <Link
                                            to="/cart"
                                            title="Add to Cart"
                                            className="add-to-cart"
                                            onClick={(e) =>
                                              handleCartClick(e, product.id)
                                            }
                                          >
                                            <i className="fas fa-shopping-cart" />
                                          </Link>
                                        </li>
                                        <li>
                                          <Link
                                            to="/wishlist"
                                            title="Wishlist"
                                            className="add-to-wishlist"
                                            onClick={(e) =>
                                              handleWishlistClick(e, product.id)
                                            }
                                          >
                                            <i className="far fa-heart" />
                                          </Link>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* PRODUCT DETAILS AREA END */}
    </>
  );
}
